import React, { useEffect, useState } from "react";
// import Hero from "./components/Hero";
// import Offers from "./components/Offers";
// import Steps from "./components/Steps";
// import Process from "./components/Process";
// import About from "./components/About";
// import Testmonial from "./components/Testmonial";
// import ForIndividual from "./components/ForIndividual";
import ServicesOverview from "./components/ServicesOverview";
// import ForBusinesses from "./components/ForBusinesses";
import FiBiSection from "./components/FiBiSection";
import UnifiedBottomCTA from "./components/UnifiedBottomCTA";
import FiBiPopUp from "../components/FiBiPopUp";
import SEOMeta from "../components/SEOMeta";
import { WebPaths } from "../../../routes/data";
import { SVLogoSquare } from "../../../images";
import HeroReskinned from "./components/HeroReskinned";
import ValuePropositionVariant from "./components/ValuePropositionVariant";
import Testimonials from "./components/Testmonial";
// import Trusted from "./components/Trusted";
// import Consultation from "./components/Consultation";
// import News from "./components/News";

// klkl

const LandingPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Check if the user has already dismissed the modal in this session
    const hasSeenModal = sessionStorage.getItem("hasSeenModal");

    if (!hasSeenModal) {
      setIsModalOpen(true);
      sessionStorage.setItem("hasSeenModal", "true"); // Set flag for this session
    }
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <SEOMeta
        title="SeamlessVisa - Simplifying U.S. Visa Applications"
        description="Get the expertise of an immigration lawyer without the price tag. Apply for your green card or fiancé visa online with SeamlessVisa."
        canonicalUrl={`https://www.seamlessvisa.com${WebPaths.Root}`}
        url={`https://www.seamlessvisa.com${WebPaths.Root}`}
        siteName="SeamlessVisa"
        publisher="https://www.facebook.com/share/1BhLA5r2Ac/"
        imageUrl={SVLogoSquare}
        imageWidth="1920"
        imageHeight="1080"
        imageType="image/png"
        twitterCard="summary_large_image"
        twitterTitle="SeamlessVisa - Simplifying U.S. Visa Applications"
        twitterDescription="Get the expertise of an immigration lawyer without the price tag. Apply for your green card or fiancé visa online with SeamlessVisa."
        twitterSite="@SeamlessVisa_"
      />
      <HeroReskinned />
      <ValuePropositionVariant />
      <ServicesOverview />
      <Testimonials />
      <FiBiSection />
      <UnifiedBottomCTA />
      <FiBiPopUp isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default LandingPage;
